import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const FractionationPage = lazy(() => import('@/pages/fractionation/ui/index'))

export const Route = createFileRoute('/_protected/expedition/fractionation')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <FractionationPage />
    </Suspense>
  ),
})
